import { AppState } from "../../../redux-configuration/AppState";

export const signUpLoadingSelector = (appState: AppState): boolean => appState.registration.signUp.loading
export const signUpSuccessSelector = (appState: AppState): boolean | null => appState.registration.signUp.success
export const signUpErrorSelector = (appState: AppState): string | undefined => appState.registration.signUp.error
